<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号" style="margin-left: 39px">
                <a-input v-model.trim="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-model="queryParam.enterpriseName"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in selectCombox" :title="type.enterpriseName" :key="type.enterpriseId"
                    >{{ type.enterpriseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                  <a-select-option v-for="type in installTypes" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="客户姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.clientName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户联系方式">
                <a-input v-model.trim="queryParam.clientMobile" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-row :gutter="24" style="margin-left: 0px">
                <a-form-item label="客户地址" style="margin-left: 26px">
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.province" @change="getselect" :allowClear="true">
                      <a-select-option
                        v-for="type in selectAllProvince"
                        :title="type.provinceName"
                        :key="type.provinceCode"
                        >{{ type.provinceName }}</a-select-option
                      >
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.city" @change="getprovinceName" :allowClear="true">
                      <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.area" :allowClear="true">
                      <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">{{
                        type.areaName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model.trim="queryParam.clientAddress" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.workName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅联系方式">
                <a-input v-model.trim="queryParam.workPhone" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderStatus" :allowClear="true">
                  <a-select-option v-for="type in order_status" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 13px">
                <a-select v-model="queryParam.orderPrincipal" :allowClear="true">
                  <a-select-option v-for="type in findByDeptId" :title="type.userName" :key="type.userId">{{
                    type.userName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="提交人" style="margin-left: 39px">
                <a-input v-model.trim="queryParam.submitBy" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="审核人" style="margin-left: 45px">
                <a-input v-model.trim="queryParam.auditBy" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.auditStatus" :allowClear="true">
                  <a-select-option value="0" title="待审核"> 待审核 </a-select-option>
                  <a-select-option value="1" title="审核通过"> 审核通过 </a-select-option>
                  <a-select-option value="2" title="审核不通过"> 审核不通过 </a-select-option>
                  <a-select-option value="9" title="撤回"> 撤回 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">
              <a-col :md="7" :sm="24">
                <a-form-item label="审核时间" style="margin-left: 26px">
                  <a-range-picker
                    style="width: 100%"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                    }"
                    @change="onChangeauditTime"
                    v-model="timeType2"
                    format="YYYY-MM-DD HH:mm:ss"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="7" :sm="24">
                <a-form-item label="提交时间" style="margin-left: 26px">
                  <a-range-picker
                    style="width: 100%"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                    }"
                    @change="onChangerangepicker"
                    v-model="timeType1"
                    format="YYYY-MM-DD HH:mm:ss"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="Ifstatus == 0" style="cursor: pointer" @click="getMore"
                ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
              <span v-if="Ifstatus == 1" style="cursor: pointer" @click="hiddenMore"
                ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty()"> 清空</a-button>
            </a-col>
          </a-row>

          <a-divider />

          <!--    表格内容-->
          <s-table size="default" ref="table" :columns="columns" :data="loadData" bordered :scroll="{ x: 3500 }">
            <span slot="action" slot-scope="text, record" style="white-space: nowrap">
              <a @click="detailsView(record)">查看</a>
              <a-divider type="vertical" v-if="record.auditStatusCode == 0" />
              <a v-if="record.auditStatusCode == 0 && beatchExamine" @click="handlemoney(record)">处理</a>
            </span>
            <span slot="orderNo" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <p>订单备注:{{ record.orderRemark }}</p>
                </template>
                <a class="hover">{{ text }} </a>
              </a-popover>
              <a title="复制"><a-icon type="copy" class="copy" @click="Copys(record)" /></a>
            </span>
            <!--<span slot="orderType" slot-scope="text, record">-->
            <!--{{text}}-->
            <!---->
            <!--</span>-->
            <span slot="enterpriseName" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <p>企业全称:{{ text }}</p>
                  <p>负责人:{{ record.enterprisePrincipal }}</p>
                  <p>联系方式:{{ record.principalPhone }}</p>
                  <p>技术人员:{{ record.technology }}</p>
                  <p>技术电话:{{ record.technologyPhone }}</p>
                  <p>技术人员2:{{ record.technology2 }}</p>
                  <p>技术2电话客服负责人:{{ record.technology2Phone }}</p>
                  <p>客服负责人:{{ record.customerService }}</p>
                  <p>客服负责人电话:{{ record.customerServicePhone }}</p>
                </template>
                <a class="hover">{{ text }} </a>
              </a-popover>
            </span>
            <span slot="marketPrincipal" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <p>负责人联系方式:{{ record.marketPrincipalPhone }}</p>
                </template>
                <a class="hover">{{ text }} </a>
              </a-popover>
            </span>
            <span slot="masterName" slot-scope="text, record">
              <span class="hover">{{ text }} </span>
              <a title="复制"><a-icon type="copy" class="copy" @click="Copys2(record)" /></a>
            </span>
            <span slot="clientName" slot-scope="text, record">
              <span class="hover">{{ text }} </span>
              <a title="复制"><a-icon type="copy" class="copy" @click="Copys3(record)" /></a>
            </span>
          </s-table>
        </a-form>
      </div>
      <edit-order-model v-if="$store.state.user_type == 1" ref="editorder" @moneyok="refresh"></edit-order-model>
      <edit-order-model1 v-else ref="editorder" @moneyok="refresh"></edit-order-model1>
    </a-card>
    <no-authority v-else></no-authority>
    <!--<order-list ref="list"></order-list>-->
  </div>
</template>

<script>
import {
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getList,
  getOrderDetail,
  getfindByDeptId,
  getfinddictAll,
} from '@/api/order/orderList'
import { getselectCombox } from '@/api/order/NewlyaddedOrderList'
import { getPriceAuditlist } from '@/api/order/moneyExamine'
import { checkPermission } from '@/utils/permissions'
import {
  getfeedbacklist,
  getFeedbackInfo,
  getPendingMattersRoleList,
  gettransfer,
  getPendingMattersResume,
  getupdateFeedback,
  getrevokeFeedback,
  getstartProcessing,
  getreply,
  getprocessingCompleted,
  getendProcessing,
  getappeal,
} from '@/api/order/feedback'
import { getAccessoryOrderlist, getselectstore, getdeliverGoods, getAccessoryNumber } from '@/api/order/PartsOrder'
import { STable } from '@/components'
import NoAuthority from '../enterprise/NoAuthority'
import pick from 'lodash.pick'
import moment from 'moment'
export default {
  name: 'PartsOrder',
  components: {
    STable,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
    NoAuthority,
    // orderList
    // 注册弹框组件
  },
  data() {
    return {
      timeType1: '',
      timeType2: '',
      findByDeptId: [],
      Ifstatus: 0,
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center',
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          align: 'center',
        },
        {
          title: '状态栏',
          dataIndex: 'orderLevel',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
          scopedSlots: { customRender: 'orderNo' },
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
          scopedSlots: { customRender: 'orderType' },
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
          scopedSlots: { customRender: 'enterpriseName' },
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center',
          scopedSlots: { customRender: 'marketPrincipal' },
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
          scopedSlots: { customRender: 'clientName' },
        },
        {
          title: '客户联系方式',
          dataIndex: 'clientMobile',
          // align:'center'
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddress',

          width: '300px',
        },
        {
          title: '师傅姓名',
          dataIndex: 'workName',
          align: 'center',
          scopedSlots: { customRender: 'masterName' },
        },
        {
          title: '师傅联系方式',
          dataIndex: 'workPhone',
          align: 'center',
        },
        {
          title: '付款方式',
          dataIndex: 'payType',
          align: 'center',
        },
        {
          title: '预约上门时间',
          dataIndex: 'reservationTime',
          align: 'center',
        },
        {
          title: '销单时间',
          dataIndex: 'saleTime',
          align: 'center',
        },
        {
          title: '核销时间',
          dataIndex: 'checkTime',
          align: 'center',
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center',
        },
        {
          title: '介入时间',
          dataIndex: 'intervenDuration',
          align: 'center',
        },
        {
          title: '提交人',
          dataIndex: 'submitBy',
          align: 'center',
        },
        {
          title: '提交时间',
          dataIndex: 'submitTime',
          align: 'center',
        },
        {
          title: '审核人',
          dataIndex: 'auditBy',
          align: 'center',
        },
        {
          title: '审核时间',
          dataIndex: 'auditTime',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
      ],
      loadData: (parameter) => {
        return getPriceAuditlist(Object.assign(parameter, this.queryParam))
      },
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      // 字典为订单状态,
      order_status: [],
      // 字典为安装类型
      installTypes: [],
      List: [],
      // 企业名称
      selectCombox: [],
      queryParam: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      pendingMatterMenu: [],
      transferible: false,
      transferform: this.$form.createForm(this),
      dealingform: this.$form.createForm(this),
      resumeform: this.$form.createForm(this),
      // 转派 表格
      ransfertrecord: '',
      pendingMattersRoleList: [],
      feedbackInfo: '',
      dealingible: false,
      resumeible: false,
      deleteible: false,
      pendingMattersResume: [],
      reslist: '',
      beatchExamine: checkPermission('beatchExamine'),
      queryList: checkPermission('order:amount:audit:query:list'),
    }
  },

  async created() {
    // 订单负责人
    this.findByDeptId = []
    await getfindByDeptId().then((res) => {
      this.findByDeptId = res
      // if (res.code === 0) {
      //   this.findByDeptId = res.data;
      //   // console.log(this.findByDeptId)
      // } else {
      //   this.$message.error(res.msg);
      // }
    })

    await getselectAllProvince().then((res) => {
      if (res.code === 0) {
        // console.log(res)
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
    let dictTypes = ['install_type', 'order_status']
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      this.installTypes = res.install_type
      this.order_status = res.order_status
    })

    // 企业名称
    this.selectCombox = []
    // isAuthority 1   数据隔离
    await getselectCombox({ isAuthority: 1 }).then((res) => {
      if (res.code === 0) {
        this.selectCombox = res.data
        // console.log(this.selectCombox)
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  methods: {
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
    handcopy(data) {
      let url = data
      let oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },

    Copys(val) {
      console.log(val)
      this.copyData =
        `订单号:` +
        val.orderNo +
        '\n' +
        `客户姓名:` +
        val.clientName +
        '\n' +
        `客户联系方式:` +
        val.clientMobile +
        '\n' +
        `客户地址:` +
        val.clientAddress
      this.handcopy(this.copyData)
    },

    Copys2(val) {
      console.log(val)
      this.copyData = `师傅姓名:` + val.workName + '\n' + `师傅联系方式:` + val.workPhone
      this.handcopy(this.copyData)
    },
    Copys3(val) {
      console.log(val)
      this.copyData =
        `客户姓名:` +
        val.clientName +
        '\n' +
        `客户联系方式:` +
        val.clientMobile +
        '\n' +
        `客户地址:` +
        val.clientAddress
      this.handcopy(this.copyData)
    },
    moment,
    empty() {
      this.queryParam = {}
      this.timeType1 = ''
      this.timeType2 = ''
    },
    refresh() {
      this.$refs.table.refresh()
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    detailsView(record) {
      this.$nextTick(() => {
        this.$refs.editorder.showeditOrder(record.orderId, 2, 0)
      })
    },
    handlemoney(record) {
      //
      let that = this
      setTimeout(function () {
        that.$refs.editorder.examine()
      }, 1000)
      this.$nextTick(() => {
        this.$refs.editorder.showeditOrder(record.orderId, 2, 1, '', record.auditStatus)
      })
    },

    onChangeauditTime(date, dateString) {
      // console.log(dateString)
      this.queryParam.auditTimeBegin = dateString[0]
      this.queryParam.auditTimeEnd = dateString[1]
    },
    onChangerangepicker(date, dateString) {
      // console.log(dateString)
      this.queryParam.submitTimeBegin = dateString[0]
      this.queryParam.submitTimeEnd = dateString[1]
    },
    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    // 市
    getselect(e) {
      console.log(e)
      // this.queryParam.cityId=''
      // this.queryParam.countyId=''
      // this.queryParam.clientAddress=''
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      // this.queryParam.countyId=''
      // this.queryParam.clientAddress=''
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async installChange(e) {
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>
